"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mobxReact = require("mobx-react");
var _react = _interopRequireWildcard(require("react"));
var _mobx = require("mobx");
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _Events = _interopRequireWildcard(require("../../../../constants/Events"));
var _TopBarAction = _interopRequireDefault(require("../../icons/top-bar-action/TopBarAction"));
var _AppUtil = require("../../../../util/AppUtil");
var _ComponentRegistry = _interopRequireDefault(require("../../../../util/ComponentRegistry"));
var _ConfigStoreConstants = require("../../../../constants/ConfigStoreConstants");
var _class, _class2, _descriptor, _descriptor2;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
const mergeActions = (topBarActions, sideMenuActions, numOfTopBarAction) => {
  const topBarActionsAsJSON = !!(topBarActions && topBarActions.length > 0 && topBarActions[0].label);
  const sideMenuActionsAsJSON = !!(sideMenuActions && sideMenuActions.length > 0 && sideMenuActions[0].label);
  if (topBarActionsAsJSON && sideMenuActionsAsJSON) {
    /** Both containing JSON objects */
    const mergedTempActions = [...topBarActions, ...sideMenuActions];
    if (topBarActions.length > numOfTopBarAction) {
      /** merge and filter */
      return {
        topBarActions: mergedTempActions.slice(0, numOfTopBarAction),
        sideMenuActions: mergedTempActions.slice(numOfTopBarAction)
      };
    }
  }
  if (sideMenuActionsAsJSON) {
    /** Only side menu actions as JSON objects or
    filter condition above not satisfied */
    return {
      topBarActions,
      sideMenuActions
    };
  }
  if (topBarActionsAsJSON) {
    /** Only top bar actions as JSON objects */
    return {
      topBarActions,
      sideMenuActions
    };
  }
  return {
    /** Both NOT containing JSON objects, can't merge with header config actions */
    topBarActions,
    sideMenuActions
  };
};
const NUMBER_OF_TOP_BAR_ACTIONS = {
  HIGH_RESOLUTION: 6,
  MEDIUM_RESOLUTION: 6,
  LOW_RESOLUTION: 3
};
const SCREEN_SIZE = {
  MEDIUM: 800,
  LOW: 750
};

/**
 * Container component for header
 */
let HeaderContainer = (0, _mobxReact.observer)(_class = (_class2 = class HeaderContainer extends _react.Component {
  constructor() {
    super();
    _initializerDefineProperty(this, "numOfTopBarAction", _descriptor, this);
    this.config = {};
    _initializerDefineProperty(this, "navConfig", _descriptor2, this);
    this._loggingService = _ServiceRegistry.default.getService("LoggingService");
    this._uiHandler = _ServiceRegistry.default.getService("UIHandler");
    this._appStore = _ServiceRegistry.default.getService("AppStore");
    this._config = this._appStore.getConfig();
    this._headerRef = _react.default.createRef();
    this._handleMouseOut = this._handleMouseOut.bind(this);
    this._handleMouseMoveOver = this._handleMouseMoveOver.bind(this);
    this._getNumOfTopBarAction = this._getNumOfTopBarAction.bind(this);
    this._touchStart = this._touchStart.bind(this);
    this._touchMove = this._touchMove.bind(this);
    this._touchEnd = this._touchEnd.bind(this);
    this._tapOnDevice = this._tapOnDevice.bind(this);
    this._getNumOfTopBarAction();
  }
  getEventForAction() {
    return this._config.isViewSDKPublic ? _Events.CoreEvents.CUSTOMIZE_TOP_BAR : _Events.default.ACTION_ICONS;
  }
  getDOMElementForEvent() {
    return this._config.isViewSDKPublic ? window.document : (0, _AppUtil.getDOMElement)();
  }
  componentDidMount() {
    _ServiceRegistry.default.getService("EventsService").registerEventListener(this.getEventForAction(), eventData => {
      var _eventData$layoutConf;
      const topBarActionList = this._appStore.enableModernViewer ? _ConfigStoreConstants.MODERN_VIEWER_TOPBAR_ACTION_LIST : _ConfigStoreConstants.TOPBAR_ACTION_LIST;
      const sortedTopbarActionsList = (0, _AppUtil.sortActionsList)(eventData.topbarConfig, topBarActionList);
      this.setNavConfig({
        topBarActions: sortedTopbarActionsList,
        sideMenuActions: eventData.sideMenuConfig,
        readAloudActions: (_eventData$layoutConf = eventData.layoutConfig) === null || _eventData$layoutConf === void 0 ? void 0 : _eventData$layoutConf.customTopBarActions
      });
    });
    window.addEventListener("resize", this._getNumOfTopBarAction);
    if (this._appStore.isHidingHeader || this._appStore.isHidingHUD) {
      this.getDOMElementForEvent().addEventListener("mousemove", this._handleMouseMoveOver);
      this.getDOMElementForEvent().addEventListener("mouseout", this._handleMouseOut);
      if (this._appStore.isOnDevice) {
        // getDOMElement().addEventListener("click", this._tapOnDevice);
        this.getDOMElementForEvent().addEventListener("touchstart", this._touchStart);
        this.getDOMElementForEvent().addEventListener("touchmove", this._touchMove);
        this.getDOMElementForEvent().addEventListener("touchend", this._touchEnd);
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this._getNumOfTopBarAction);
    if (this._appStore.isHidingHeader || this._appStore.isHidingHUD) {
      this.getDOMElementForEvent().removeEventListener("mousemove", this._handleMouseMoveOver);
      this.getDOMElementForEvent().removeEventListener("mouseout", this._handleMouseOut);
      if (this._appStore.isOnDevice) {
        // window.document.removeEventListener("click", this._tapOnDevice);
        this.getDOMElementForEvent().removeEventListener("touchstart", this._touchStart);
        this.getDOMElementForEvent().removeEventListener("touchmove", this._touchMove);
        this.getDOMElementForEvent().removeEventListener("touchend", this._touchEnd);
      }
    }
  }
  setNavConfig(value) {
    this.navConfig = value;
  }
  setNumOfTopBarAction(value) {
    let numOfTopBarAction = value;
    if (numOfTopBarAction > 3) {
      const commentsApi = _ServiceRegistry.default.getService("CommentsApi");
      if (commentsApi.isFreetextEnabled()) numOfTopBarAction += 1;
      if (commentsApi.isEraserToolEnabled()) numOfTopBarAction += 1;
    }
    this.numOfTopBarAction = numOfTopBarAction;
  }
  _getNumOfTopBarAction() {
    if (window.innerWidth >= SCREEN_SIZE.MEDIUM) {
      this.setNumOfTopBarAction(NUMBER_OF_TOP_BAR_ACTIONS.HIGH_RESOLUTION);
    } else if (window.innerWidth >= SCREEN_SIZE.LOW) {
      this.setNumOfTopBarAction(NUMBER_OF_TOP_BAR_ACTIONS.MEDIUM_RESOLUTION);
    } else {
      this.setNumOfTopBarAction(NUMBER_OF_TOP_BAR_ACTIONS.LOW_RESOLUTION);
    }
  }
  _touchStart() {
    // Reset any touch move
    this._noTouchMovement = true;
  }
  _touchMove() {
    this._noTouchMovement = false;
  }
  _touchEnd() {
    if (this._noTouchMovement) {
      this._tapOnDevice();
    }
  }
  _tapOnDevice() {
    const height = this._config.isViewSDKPublic ? window.innerHeight : (0, _AppUtil.getDOMElement)().clientHeight;
    this._uiHandler.showHeaderAndHUD(height);
  }
  _handleMouseOut() {
    const height = this._config.isViewSDKPublic ? window.innerHeight : (0, _AppUtil.getDOMElement)().clientHeight;
    this._uiHandler.fadeHeaderAndHUD(height);
  }
  _handleMouseMoveOver(event) {
    if (!event || this._appStore.searchOpen) {
      return;
    }
    let reactElement = {};
    if (!this._config.isViewSDKPublic) {
      reactElement = (0, _AppUtil.getDOMElement)().getBoundingClientRect();
    }
    const clientY = this._config.isViewSDKPublic ? event.clientY : event.clientY - reactElement.top;
    if (this._uiHandler.inHoverRangeOfHeaderAndHUD(clientY)) {
      this._uiHandler.showHeaderAndHUD(clientY);
    }
  }
  getProps() {
    if (this._config.isViewSDKPublic) {
      return {
        dropinName: this._appStore.dropinName,
        searchOpen: this._appStore.searchOpen,
        hasAnnotationTools: !this._appStore.shouldHideAnnotationTools
      };
    }
    return {};
  }
  _adjustSearchUI(setToTop) {
    if (this._config.isViewSDKPublic) {
      if (!this._sElement) {
        const sClass = "SearchInputUI__SearchInputUI___15hhd";
        const cList = document.getElementsByClassName(sClass);
        if (cList && cList.length > 0) {
          this._sElement = cList[0];
        }
      }
      if (this._sElement) {
        this._sElement.style.top = `${setToTop}px`;
      }
    }
  }
  render() {
    if (this._appStore.isHidingHeader || this._appStore.isHidingHUD) {
      if (this._appStore.searchOpen) {
        if (this._headerRef && this._headerRef.style) {
          if (this._appStore.enableModernViewer && this._appStore.inFullScreen) {
            this._headerRef.style.opacity = 1;
          } else {
            this._headerRef.style.opacity = 0.8;
          }
        }
      } else {
        // Make sure header auto hide, as search might close due to keyboard action
        this._uiHandler.showHeaderAndHUD(100);
      }
    }
    if (this._appStore.searchOpen) {
      this._adjustSearchUI(this._setToTop);
    }
    Object.assign(this.config, this.navConfig);
    const {
      /** List of actions which will be placed in the top bar */
      topBarActions,
      /** List of actions which will be placed in the side menu */
      sideMenuActions,
      /** List of read aloud actions */
      readAloudActions
    } = this.config;
    const shouldDisplayReadAloudTools = !!readAloudActions;
    // eslint-disable-next-line max-len
    const mergedActions = mergeActions(shouldDisplayReadAloudTools ? readAloudActions : topBarActions, sideMenuActions, this.numOfTopBarAction);
    let topBarMenus = [];
    if (mergedActions.topBarActions) {
      topBarMenus = [...mergedActions.topBarActions];
    }
    let sideMenus = [];
    if (mergedActions.sideMenuActions) {
      sideMenus = [...mergedActions.sideMenuActions];
    }
    let searchAction;
    topBarMenus.forEach(val => {
      if (val.id === "documentSearch") {
        searchAction = val;
      }
    });
    if (!searchAction) {
      sideMenus.forEach(val => {
        if (val.id === "documentSearch") {
          searchAction = val;
        }
      });
    }
    let showTopBar = this._appStore.getConfig().showTopBar;
    if (this._appStore.enableModernViewer && this._appStore.isSizedPreset) {
      showTopBar = this._appStore.inFullScreen;
    }
    if (!showTopBar) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "none"
        }
      }, searchAction && /*#__PURE__*/_react.default.createElement(_TopBarAction.default, {
        action: searchAction
      }));
    }
    if (searchAction) {
      this.searchAction = searchAction;
    }
    if (this.searchAction && this._appStore.searchOpen && this._appStore.adjustSearchUI) {
      topBarMenus = topBarMenus.filter(val => val.id !== "documentSearch");
      topBarMenus.push(_objectSpread(_objectSpread({}, this.searchAction), {}, {
        onClick: () => {}
      }));
      setTimeout(() => {
        const documentSearch = document.getElementById("documentSearch");
        if (documentSearch && documentSearch.childNodes && documentSearch.childNodes.length > 0 && documentSearch.childNodes[0].childNodes && documentSearch.childNodes[0].childNodes.length > 0) {
          documentSearch.childNodes[0].childNodes[0].style.fill = "#1473e6";
        }
      }, 10);
    } else if (this.searchAction) {
      const search = topBarMenus.find(menu => menu.id === "documentSearch") || sideMenus.find(menu => menu.id === "documentSearch");
      // Handling post conversion cases
      if (!search) {
        topBarMenus.push(this.searchAction);
      }
    }
    const printAction = topBarMenus.filter(val => val.id === "documentPrint");
    if (printAction && printAction.length === 1) {
      topBarMenus = topBarMenus.filter(val => val.id !== "documentPrint");
      sideMenus.push(printAction[0]);
    }
    if (!this._appStore.configStore.showDownload) {
      if (sideMenus) {
        sideMenus = sideMenus.filter(val => val.id !== "documentDownload");
      }
    }
    if (!this._appStore.configStore.showPrint) {
      if (sideMenus) {
        sideMenus = sideMenus.filter(val => val.id !== "documentPrint");
      }
    }
    if (sideMenus && sideMenus.length > 1) {
      // make sure print is not the first
      const printA = sideMenus.filter(val => val.id === "documentPrint");
      if (printA && printA.length === 1) {
        sideMenus = sideMenus.filter(val => val.id !== "documentPrint");
        sideMenus.push(printA[0]);
      }
    }
    if (sideMenus && sideMenus.length === 1 && !this._appStore.configStore.hasAdobeMenuActions()) {
      topBarMenus = [...topBarMenus, ...sideMenus];
      sideMenus = [];
    }
    const setRef = ref => {
      this._headerRef = ref;
      this._uiHandler.initialiseHeaderRef(ref);
    };
    let topBarAnnotationTools;
    if (this._appStore.enableModernViewer) {
      if (topBarMenus) {
        if (shouldDisplayReadAloudTools) {
          topBarMenus = (0, _AppUtil.sortActionsList)(topBarMenus.filter(val => _ConfigStoreConstants.MODERN_VIEWER_TOPBAR_READ_ALOUD_ACTION_LIST.includes(val.id)), _ConfigStoreConstants.MODERN_VIEWER_TOPBAR_READ_ALOUD_ACTION_LIST);
        } else {
          topBarAnnotationTools = (0, _AppUtil.sortActionsList)(topBarMenus, _ConfigStoreConstants.MODERN_VIEWER_TOPBAR_ANNOTATION_TOOL_IDS);
          topBarMenus = topBarMenus.filter(val => _ConfigStoreConstants.MODERN_VIEWER_TOPBAR_ANNOTATION_TOOL_IDS.indexOf(val.id) === -1);
        }
      }
    }
    if (this._appStore.shouldHideAnnotationTools) {
      if (topBarMenus) {
        topBarMenus = topBarMenus.filter(val => _ConfigStoreConstants.ANNOTATION_TOOL_IDS.indexOf(val.id) === -1);
      }
      if (sideMenus) {
        sideMenus = sideMenus.filter(val => _ConfigStoreConstants.ANNOTATION_TOOL_IDS.indexOf(val.id) === -1);
      }
    }
    if (this._appStore.getActionConfig("preview").enableSearchAPIs) {
      if (topBarMenus) {
        topBarMenus = topBarMenus.filter(val => val.id !== "documentSearch");
      }
      if (sideMenus) {
        sideMenus = sideMenus.filter(val => val.id !== "documentSearch");
      }
    }
    let sortedSideMenus = sideMenus;
    if (sortedSideMenus) {
      const sideMenusOrderList = this._appStore.enableModernViewer ? _ConfigStoreConstants.MODERN_VIEWER_SIDE_MENUS_ORDER_LIST : _ConfigStoreConstants.SIDE_MENUS_ORDER_LIST;
      sortedSideMenus = (0, _AppUtil.sortActionsList)(sideMenus, sideMenusOrderList);
    }
    const makeToolsInactive = this._appStore.isIntegration && this._appStore.isToolsInactive;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ComponentRegistry.default.getComponent("HeaderView", _objectSpread({
      topBarActions: topBarMenus || [],
      sideMenuActions: sortedSideMenus || [],
      topBarAnnotationTools,
      inFullScreen: this._appStore.inFullScreen,
      showFullScreen: this._appStore.configStore.showFullScreen,
      exitPDFViewerType: this._appStore.configStore.exitPDFViewerType,
      setRef,
      viewMode: this._appStore.currentViewMode,
      searchOpen: this._appStore.searchOpen,
      previewRef: this._appStore.previewRef,
      fileStatus: this._appStore.fileStatus,
      makeToolsInactive,
      shouldDisplayReadAloudTools
    }, this.getProps())));
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "setNavConfig", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "setNavConfig"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setNumOfTopBarAction", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "setNumOfTopBarAction"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "numOfTopBarAction", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return NUMBER_OF_TOP_BAR_ACTIONS.HIGH_RESOLUTION;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "navConfig", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
})), _class2)) || _class;
var _default = exports.default = HeaderContainer;